var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRevenue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_370_289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5938 11.5625V12.5C13.5937 12.9973 13.3962 13.4742 13.0446 13.8258C12.6929 14.1775 12.216 14.375 11.7188 14.375H2.34375C1.84647 14.375 1.36956 14.1775 1.01792 13.8258C0.666294 13.4742 0.46875 12.9973 0.46875 12.5V5.9375C0.46875 5.44022 0.666294 4.96331 1.01792 4.61167C1.36956 4.26004 1.84647 4.0625 2.34375 4.0625H11.7188C12.216 4.0625 12.6929 4.26004 13.0446 4.61167C13.3962 4.96331 13.5937 5.44022 13.5938 5.9375V6.875",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7188 4.06252L10.2631 1.15127C10.2081 1.04111 10.1319 0.942862 10.0388 0.862157C9.94581 0.781452 9.83779 0.719867 9.72095 0.680922C9.60411 0.641976 9.48075 0.626433 9.3579 0.63518C9.23506 0.643927 9.11514 0.676793 9.005 0.731899L2.34375 4.06252",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5938 11.5625C13.8424 11.5625 14.0808 11.4637 14.2567 11.2879C14.4325 11.1121 14.5312 10.8736 14.5312 10.625V7.8125C14.5312 7.56386 14.4325 7.3254 14.2567 7.14959C14.0808 6.97377 13.8424 6.875 13.5938 6.875H11.25C10.6284 6.875 10.0323 7.12193 9.59272 7.56147C9.15318 8.00101 8.90625 8.59715 8.90625 9.21875C8.90625 9.84035 9.15318 10.4365 9.59272 10.876C10.0323 11.3156 10.6284 11.5625 11.25 11.5625H13.5938Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 8.98438C11.2964 8.98437 11.3417 8.99812 11.3802 9.02387C11.4188 9.04963 11.4488 9.08623 11.4665 9.12906C11.4843 9.17188 11.4889 9.21901 11.4799 9.26447C11.4708 9.30994 11.4485 9.3517 11.4157 9.38448C11.383 9.41726 11.3412 9.43958 11.2957 9.44862C11.2503 9.45766 11.2031 9.45302 11.1603 9.43528C11.1175 9.41754 11.0809 9.3875 11.0551 9.34896C11.0294 9.31042 11.0156 9.2651 11.0156 9.21875C11.0156 9.15659 11.0403 9.09698 11.0843 9.05302C11.1282 9.00907 11.1878 8.98438 11.25 8.98438",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_370_289"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevenue);
export default __webpack_public_path__ + "static/media/Revenue.edfec03d.svg";
export { ForwardRef as ReactComponent };